function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e1) {
        return false;
    }
}
function _create_super(Derived) {
    var hasNativeReflectConstruct = _is_native_reflect_construct();
    return function _createSuperInternal() {
        var Super = _get_prototype_of(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _get_prototype_of(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possible_constructor_return(this, result);
    };
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e1) {
            op = [
                6,
                e1
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { editBillingDetails, getFullUserDetails } from "@common/actions/user-details";
import RichText from "@common/components/BoxDetailsTab/RichText";
import Spinner from "@common/components/Spinner";
import authentication from "@common/reducers/authentication";
import { hashCode } from "@common/utils/helpers";
import PrismicClient from "@common/utils/prismic";
import { ROUTE_LIVE } from "@config/constants";
import { SNACKBAR_AUTOHIDE_TIMEOUT, SNACKBAR_VARIANT_ERROR } from "@config/constants";
import Button from "@material-ui/core/Button";
import { withSnackbar } from "notistack";
import React, { PureComponent } from "react";
import { connect } from "react-redux";
var TermsAndConditionsPage = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    _inherits(TermsAndConditionsPage, PureComponent);
    var _super = _create_super(TermsAndConditionsPage);
    function TermsAndConditionsPage(props) {
        _class_call_check(this, TermsAndConditionsPage);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            confirmPending: false,
            prismicData: null
        };
        _this.handleConfirm = _this.handleConfirm.bind(_assert_this_initialized(_this));
        return _this;
    }
    _create_class(TermsAndConditionsPage, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this = this;
                return _async_to_generator(function() {
                    var prismicData, e1, _this_props_i18n_errors_prismic, localizedErrorMessage;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!PrismicClient.hasPrismic()) return [
                                    2
                                ];
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    PrismicClient.getTOS()
                                ];
                            case 2:
                                prismicData = _state.sent();
                                _this.setState({
                                    prismicData: prismicData[0]
                                });
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                e1 = _state.sent();
                                localizedErrorMessage = ((_this_props_i18n_errors_prismic = _this.props.i18n.errors.prismic) === null || _this_props_i18n_errors_prismic === void 0 ? void 0 : _this_props_i18n_errors_prismic[e.message]) || _this.props.i18n.errors.generic;
                                _this.props.enqueueSnackbar(localizedErrorMessage, {
                                    variant: SNACKBAR_VARIANT_ERROR,
                                    autoHideDuration: SNACKBAR_AUTOHIDE_TIMEOUT
                                });
                                return [
                                    3,
                                    4
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "handleConfirm",
            value: function handleConfirm() {
                var _this = this;
                return _async_to_generator(function() {
                    var _this_props, i18n, userDetails, authentication, _$editBillingDetails, _$getFullUserDetails, history, token, data, res, error;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this_props = _this.props, i18n = _this_props.i18n, userDetails = _this_props.userDetails, authentication = _this_props.authentication, _$editBillingDetails = _this_props.editBillingDetails, _$getFullUserDetails = _this_props.getFullUserDetails, history = _this_props.history;
                                token = authentication.token;
                                data = {
                                    token: token,
                                    cf_terms: true
                                };
                                _this.setState({
                                    confirmPending: true
                                });
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    4,
                                    ,
                                    5
                                ]);
                                return [
                                    4,
                                    _$editBillingDetails(data)
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    4,
                                    _$getFullUserDetails()
                                ];
                            case 3:
                                res = _state.sent();
                                history.push(ROUTE_LIVE);
                                return [
                                    3,
                                    5
                                ];
                            case 4:
                                error = _state.sent();
                                console.log(error);
                                return [
                                    3,
                                    5
                                ];
                            case 5:
                                _this.setState({
                                    confirmPending: false
                                });
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "render",
            value: function render() {
                var _this_props = this.props, i18n = _this_props.i18n, userDetails = _this_props.userDetails, authentication = _this_props.authentication;
                var cf_terms = userDetails.cf_terms;
                var prismicData = this.state.prismicData;
                if (!prismicData) return null;
                return /*#__PURE__*/ _jsxs("div", {
                    className: "modal policy",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "message-wrapper",
                            style: {
                                margin: 60,
                                "padding-bottom": cf_terms === false ? 20 : 0
                            },
                            children: [
                                /*#__PURE__*/ _jsx("h1", {
                                    children: prismicData.title
                                }),
                                /*#__PURE__*/ _jsx("p", {
                                    className: "created font-weight-bold",
                                    children: prismicData.created
                                }),
                                /*#__PURE__*/ _jsx("p", {
                                    className: "font-weight-bold",
                                    children: prismicData.valid_from
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "subtitle-holder",
                                    children: prismicData.subtitle.map(function(data) {
                                        return /*#__PURE__*/ _jsx(RichText, _object_spread({}, data), data.text);
                                    })
                                }),
                                prismicData.section.map(function(param) {
                                    var section_title = param.section_title, section_text = param.section_text;
                                    return /*#__PURE__*/ _jsxs("div", {
                                        className: "policy-section",
                                        children: [
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "policy-title",
                                                children: section_title
                                            }),
                                            section_text.map(function(text, i) {
                                                var keyCode = "".concat(i, "_").concat(hashCode(text.text));
                                                return /*#__PURE__*/ _jsx(RichText, _object_spread({}, text), keyCode);
                                            })
                                        ]
                                    }, section_title);
                                })
                            ]
                        }),
                        cf_terms === false && /*#__PURE__*/ _jsxs("div", {
                            className: "cf-terms-footer",
                            children: [
                                /*#__PURE__*/ _jsx("span", {
                                    className: "cf-terms-subtitle",
                                    children: "За да ползвате услугата на ElementalTV, трябва да се съгласите с Общите условия"
                                }),
                                /*#__PURE__*/ _jsxs(Button, {
                                    classes: {
                                        label: "ux-button-label"
                                    },
                                    className: "button raised half-width pointer terms-confirm-button",
                                    onClick: this.handleConfirm,
                                    disabled: this.state.confirmPending,
                                    children: [
                                        this.state.confirmPending && /*#__PURE__*/ _jsx(Spinner, {}),
                                        !this.state.confirmPending && "Потвърди >"
                                    ]
                                })
                            ]
                        })
                    ]
                });
            }
        }
    ]);
    return TermsAndConditionsPage;
}(PureComponent);
var mapStateToProps = function(param) {
    var i18n = param.i18n;
    return {
        i18n: i18n
    };
};
export default withSnackbar(connect(mapStateToProps, {
    editBillingDetails: editBillingDetails,
    getFullUserDetails: getFullUserDetails
})(TermsAndConditionsPage));
